export { useKonamiTapper } from './useKonamiTapper'
